import script from "./operation-record.vue?vue&type=script&lang=tsx&setup=true"
export * from "./operation-record.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__